import React from "react";
import BookBuBTable from "./CommonTable/BookBubTable";

const BookBub: React.FC = () => {
  return (
    <div className="mx-6">
      <BookBuBTable />
    </div>
  );
};
export default BookBub;

